<template>
    <v-toolbar-title class="mr-2">
        <router-link
            :to="{name: 'dashboard'}" exact>
            <v-img
                max-width="220"
                min-width="100"
                :src="require('../assets/selteclogo.png')">
            </v-img>
        </router-link>
    </v-toolbar-title>
</template>

<script>
export default {
	name: 'Logo',
};
</script>
